import React from 'react';
import ReactDOM from 'react-dom/client';

const render = async () => {
  const rootElement = document.getElementById('root');
  const App = require('./features/main').default;
  if (!rootElement) {
    return;
  }

  ReactDOM.createRoot(rootElement).render(
    <>
      <App />
    </>,
  );
};

render();

// if (process.env.NODE_ENV === 'development' && module.hot) {
//   module.hot.accept('./app/App', render);
// }
